import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';


@Injectable({
  providedIn: 'root'
})
export class RedirectGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.authService.currentUserValue;
    if (user) {
      if (user['role'] == 'Admin') {
        this.router.navigate(['/admin']);
      }
      if (user['role'] == 'Pharmacy') {
        this.router.navigate(['/pharmacy']);
      }
      if (user['role'] == 'drug_store') {
        this.router.navigate(['/pharmacy']);
      }
      if (user['user_role'] == 'Patient') {
        this.router.navigate(['/patient']);
      }
      if (user['user_role'] == 'Doctor') {
        this.router.navigate(['/doctor']);
      }
      if (user['role'] == 'Hospital') {
        this.router.navigate(['/hospital']);
      }
      return true;
    }
    this.router.navigate(['/front-site/home']);
    return false;
  }
}
